import { Host, h } from '@stencil/core';
export class AibaBazaarvoiceRatings {
  constructor() {
    /* istanbul ignore next */
    this.handleBVDivHydrated = async () => {
      var _a, _b, _c, _d, _e, _f;
      const bvDivRef = document.querySelector(`#aiba-bv-div-${this.upc}`);
      if ((bvDivRef === null || bvDivRef === void 0 ? void 0 : bvDivRef.innerHTML.startsWith('<div data-bv-show=')) &&
        ((_b = (_a = document.querySelector('.bv-primary')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.bvReady) &&
        document.querySelector('.bv-primary').childNodes.length &&
        !this.summary) {
        this.bazaarvoiceWrapperRef.innerHTML = bvDivRef.innerHTML;
        const element = document.getElementById(`aiba-bv-div-${this.upc}`);
        setTimeout(() => {
          element.remove();
        }, 0);
      }
      else if ((bvDivRef === null || bvDivRef === void 0 ? void 0 : bvDivRef.innerHTML.startsWith('<div data-bv-show=')) &&
        ((_d = (_c = document.querySelector('.bv-primary')) === null || _c === void 0 ? void 0 : _c.dataset) === null || _d === void 0 ? void 0 : _d.bvReady) &&
        ((_e = document.querySelector('.bv-primary')) === null || _e === void 0 ? void 0 : _e.childNodes.length) &&
        ((_f = document.querySelector('.bv_main_container_row_flex')) === null || _f === void 0 ? void 0 : _f.childNodes.length) &&
        this.summary) {
        //TBD - summary ratings
        this.bazaarvoiceWrapperRef.innerHTML = bvDivRef.innerHTML;
        const element = document.getElementById(`aiba-bv-div-${this.upc}`);
        setTimeout(() => {
          element.remove();
        }, 0);
      }
    };
    this.handleLoadBazaarVoiceRating = () => {
      const bvDivRef = document.querySelector(`#aiba-bv-div-${this.upc}`);
      if (!bvDivRef) {
        const section = document.createElement('section');
        section.id = `aiba-bv-div-${this.upc}`;
        section.style.display = 'none !important';
        document.getElementsByTagName('aiba-app')[0].parentElement.insertBefore(section, document.getElementsByTagName('aiba-app')[0]);
        const insertableBVDiv = this.summary
          ? `<div data-bv-show="rating_summary" data-bv-product-id=${this.upc} class="bv-primary" />`
          : `<div data-bv-show="inline_rating" data-bv-product-id=${this.upc} class="bv-primary" />`;
        section.innerHTML = insertableBVDiv;
        /* istanbul ignore next */
        typeof window !== 'undefined' ? (window.BV ? (section.innerHTML = insertableBVDiv) : null) : null;
      }
      // Set up MutationObserver instead of DOMSubtreeModified
      const targetNode = document.querySelector(`#aiba-bv-div-${this.upc}`);
      const config = { childList: true, subtree: true, attributes: true };
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            this.handleBVDivHydrated();
            observer.disconnect(); // Stop observing after handling
            break;
          }
        }
      });
      observer.observe(targetNode, config);
    };
    this.upc = undefined;
    this.summary = undefined;
    this.classes = undefined;
    this.styles = undefined;
  }
  componentWillLoad() {
    this.handleLoadBazaarVoiceRating();
  }
  updateBazaarvoiceChanged() {
    this.handleLoadBazaarVoiceRating();
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "bv-wrapper" }, h("div", { class: `bv-content ${this.upc}`, ref: el => (this.bazaarvoiceWrapperRef = el) }))));
  }
  static get is() { return "aiba-bazaarvoice-ratings"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-bazaarvoice-ratings.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-bazaarvoice-ratings.css"]
    };
  }
  static get properties() {
    return {
      "upc": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "upc",
        "reflect": false
      },
      "summary": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "summary",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      }
    };
  }
  static get listeners() {
    return [{
        "name": "event-bazaarvoice-data-changed",
        "method": "updateBazaarvoiceChanged",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
/* IGNORED TEST CASES

- [handleBVDivHydrated] -> no. of Lines = 24-51
  REASON :(window.document is not working in test env + focus of element is not being able to tested properly)

*/
//# sourceMappingURL=aiba-bazaarvoice-ratings.js.map
